// extracted by mini-css-extract-plugin
module.exports = {"basic-info":"_02712f2b3b--basic-info--l0Be3","transport-accessibility":"_02712f2b3b--transport-accessibility--gAWBD"};